<template>
  <div class="mt-n5">
    <v-checkbox class="opt-in-checkbox" v-model="optIn">
      <template v-slot:label>
        <span
          v-html="text"
          @click.stop="
            () => {
              optIn === optIn;
            }
          "
        ></span>
      </template>
    </v-checkbox>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["text", "value"],

  data() {
    return {
      optIn: false,
    };
  },

  computed: {
    ...mapGetters(["buyer"]),
  },

  mounted() {
    if (this.value === "C") this.optIn = true;
    else if (this.value === "U") this.optIn = false;

    this.$store.commit("SET_BUYER_DATA", {
      ...this.buyer,
      opt_in: this.optIn,
    });
  },

  watch: {
    optIn(v) {
      this.$store.commit("SET_BUYER_DATA", {
        ...this.buyer,
        opt_in: v,
      });
    },
  },
};
</script>
